import React from 'react';

const Card = () => {
    return (
        <div className="bg-bgprimary rounded-2xl p-4 w-full max-w-sm">
            <h2 className="text-center text-dark font-quicksand font-bold text-lg mb-4">Westbreeze</h2>
            <div className="bg-aths rounded-2xl p-4">
                <div className="space-y-2">
                    <div className="border-2 border-white rounded-md h-10 bg-bgprimary w-20"></div>
                    <div className="border-2 border-white rounded-md h-10 bg-orange w-10"></div>
                    <div className="border-2 border-white rounded-md h-10 bg-bgprimary w-20"></div>
                    <div className="border-2 border-white rounded-md h-10 bg-bgprimary w-20"></div>
                    <div className="border-2 border-white rounded-md h-10 bg-bgprimary w-20"></div>
                    <div className="border-2 border-black rounded-md h-10 bg-white w-24"></div>
                </div>
            </div>
            <div className="flex items-center space-x-2 mt-4">
                <div className="bg-aths rounded-full w-10 h-10"></div>
                <div className="bg-aths h-5 w-24 rounded"></div>
            </div>
            <div className="mt-4 space-y-2">
                <div className="bg-aths h-5 rounded"></div>
                <div className="bg-aths h-5 rounded"></div>
                <div className="bg-aths h-5 rounded"></div>
                <div className="bg-aths h-5 rounded"></div>
            </div>
        </div>
    );
};

const CardGridSkelton = () => {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 p-4">
            <Card />
            <Card />
            <Card />
        </div>
    );
};

export default CardGridSkelton;
